var map = {
	"./foto1.jpg": 9968,
	"./foto2.jpg": 9369,
	"./foto3.jpg": 192,
	"./foto4.jpg": 7459,
	"./foto5.jpg": 3071,
	"./foto6.jpg": 3641,
	"./foto7.jpg": 8283,
	"./foto8.jpg": 9375,
	"./foto9.jpg": 5018,
	"assets/photo/fashion-photography/overTheRainbow/foto1.jpg": 9968,
	"assets/photo/fashion-photography/overTheRainbow/foto2.jpg": 9369,
	"assets/photo/fashion-photography/overTheRainbow/foto3.jpg": 192,
	"assets/photo/fashion-photography/overTheRainbow/foto4.jpg": 7459,
	"assets/photo/fashion-photography/overTheRainbow/foto5.jpg": 3071,
	"assets/photo/fashion-photography/overTheRainbow/foto6.jpg": 3641,
	"assets/photo/fashion-photography/overTheRainbow/foto7.jpg": 8283,
	"assets/photo/fashion-photography/overTheRainbow/foto8.jpg": 9375,
	"assets/photo/fashion-photography/overTheRainbow/foto9.jpg": 5018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9994;